export default {
  offer: '/offer/:Id',
  offerSubmission: '/offer/form/:uuid',
  offerPortal: '/offer/details/:uuid',
};
